import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import { CreatePaymentSessionApi } from "../../../api/request/payments/payments";
import siteConfig from "../../../config";

const PaymentModal = ({ isOpen, setIsOpen, payment, setStatusData }) => {
  const [form] = Form.useForm();
  const [paymentType, setPaymentType] = useState("interac");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (paymentType) form.setFieldsValue({ payment_type: paymentType });
  }, [paymentType]);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const params = { file_id: payment?.file_id, ...values };
      const { data } = await CreatePaymentSessionApi(params);
      if (data?.status) {
        form.resetFields();
        toast.success(data?.message);
        setStatusData();
        setIsOpen(false);
        if (data?.data?.href) window.open(data?.data?.href, "_blank");
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title="Payment">
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item
          name="payment_type"
          rules={[
            { required: true, message: "Please select a payment method" },
          ]}
        >
          <div className="flex items-center justify-center gap-5">
            {/* <div
              className={`w-1/2 border p-4 rounded-md cursor-pointer text-center ${paymentType === "card" ? "border-primary bg-secondaryLight" : "border-gray-300"}`}
              onClick={() => {
                form.setFieldsValue({ payment_type: "card" });
                setPaymentType("card");
              }}
            >
              <div className="flex flex-col items-center gap-3">
                <img src="assets/images/Card.png" alt="card" width={50} />
                <p>Card</p>
              </div>
            </div> */}

            <div
              className={`w-1/2 border p-4 rounded-md cursor-pointer text-center ${
                paymentType === "interac"
                  ? "border-primary bg-secondaryLight"
                  : "border-gray-300"
              }`}
              onClick={() => {
                form.setFieldsValue({ payment_type: "interac" });
                setPaymentType("interac");
              }}
            >
              <div className="flex flex-col items-center gap-3">
                <img src="assets/images/Etransfer.png" alt="card" width={50} />
                <p>Interac e-Transfer</p>
              </div>
            </div>
          </div>
        </Form.Item>

        {paymentType === "interac" && (
          <>
            <div className="mb-5">
              <div className="mb-3 text-[14px]">
                <p className="font-semibold">
                  Recipient Name :{" "}
                  <span className="font-medium text-gray-600">
                    {siteConfig?.intractName}
                  </span>
                </p>
                <p className="font-semibold">
                  Recipient Email :{" "}
                  <span className="font-medium text-gray-600">
                    {siteConfig?.intractEmail}
                  </span>
                </p>
              </div>
              <p className="text-gray-600 text-[14px]">
                Enter the payment amount as per your invoice. Once you've sent
                the payment, please enter the email address used for the
                transfer in the form below. This will help us verify and process
                your payment quickly.
              </p>
            </div>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input placeholder="Enter your email" size="large" />
            </Form.Item>
          </>
        )}

        <div className="text-center">
          <LoadableButton
            className="bg-secondary text-sm text-white font-medium px-8 py-2 mt-4 rounded-lg"
            type="submit"
            lable={`${
              paymentType === "interac" ? "Send For Verification" : "Pay"
            }`}
            isLoading={isLoading}
            loadingLable={`${
              paymentType === "interac" ? "Sending Request..." : "Paying..."
            }`}
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default PaymentModal;
